// Admin auth helper — wraps the new JWT flow plus the legacy single-password
// header so the team handover is non-breaking.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LS_TOKEN = "tok-admin-token";
const LS_USER = "tok-admin-user";
const LS_LEGACY = "tok-admin-pass"; // kept for backwards compatibility

export const ROLE_LABEL = {
  owner: "Owner",
  editor: "Editor",
  viewer: "Viewer",
};

export const ROLE_RANK = { viewer: 0, editor: 1, owner: 2 };

export function getToken() {
  return localStorage.getItem(LS_TOKEN) || "";
}

export function getLegacyPassword() {
  return localStorage.getItem(LS_LEGACY) || "";
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(LS_USER);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function authHeaders() {
  const token = getToken();
  if (token) return { Authorization: `Bearer ${token}` };
  const legacy = getLegacyPassword();
  if (legacy) return { "X-Admin-Password": legacy };
  return {};
}

export function adminClient() {
  // Returns an axios instance pre-configured with the right auth headers.
  return axios.create({
    baseURL: API,
    headers: authHeaders(),
  });
}

export async function loginWithEmail(email, password) {
  const { data } = await axios.post(`${API}/admin/auth/login`, {
    email,
    password,
  });
  localStorage.setItem(LS_TOKEN, data.token);
  localStorage.setItem(LS_USER, JSON.stringify(data.user));
  localStorage.removeItem(LS_LEGACY); // ensure bearer takes over
  return data.user;
}

export async function loginWithLegacyPassword(password) {
  await axios.post(`${API}/admin/verify`, { password });
  localStorage.setItem(LS_LEGACY, password);
  localStorage.removeItem(LS_TOKEN);
  localStorage.removeItem(LS_USER);
  return {
    id: "legacy-admin",
    email: "legacy@admin.local",
    name: "Legacy Admin",
    role: "owner",
  };
}

export async function refreshMe() {
  const token = getToken();
  if (!token) return null;
  try {
    const { data } = await axios.get(`${API}/admin/auth/me`, {
      headers: authHeaders(),
    });
    localStorage.setItem(LS_USER, JSON.stringify(data));
    return data;
  } catch {
    return null;
  }
}

export function logout() {
  localStorage.removeItem(LS_TOKEN);
  localStorage.removeItem(LS_USER);
  localStorage.removeItem(LS_LEGACY);
}

export function canEdit(user) {
  return (
    user && ROLE_RANK[user.role] != null && ROLE_RANK[user.role] >= ROLE_RANK.editor
  );
}

export function canManageUsers(user) {
  return user && user.role === "owner";
}
